import { Navigate, useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";
import SavePreagendamientoPymes from "../../shared/componente/save_preagendamiento_pymes/SavePreagendamientoPymes";
import { useGetPreventaPymesById } from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";

export default function CreatePreagendamientoPymesPage() {

  const { id, uid } = useParams();

  const {
    isLoading,
    data,
  } = useGetPreventaPymesById(id!);

  if (isLoading)
    return <LoaderComponent />

  if (!data)
    return <Navigate to={ROUTER_PATHS.ventasPymes.preventaNav} />


  return (
    <SavePreagendamientoPymes
      title="Preagendamiento PYMES"
      dataPreventa={data}
      uid={uid!}
    />
  )

}